import { Currency } from "@redotech/money/currencies";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import {
  CheckoutOptimizationWidgetType,
  PurchaseCheckoutBlockRenderTarget,
} from "./widget";

const baseWidgetSchema = z.object({
  /**
   * Defined `id` means the widget is existing and needs to be updated.
   * Undefined `id` means the widget is new and needs to be created
   */
  id: zExt.objectId().optional(),
  target: createEnum(PurchaseCheckoutBlockRenderTarget).optional(),
  enabled: z.boolean(),
});

export const checkoutWidgetsSchema = z.object({
  [CheckoutOptimizationWidgetType.THRESHOLD_UPSELL]: baseWidgetSchema.extend({
    type: z.literal(CheckoutOptimizationWidgetType.THRESHOLD_UPSELL),
    thresholdAmount: z.number(),
    currency: createEnum(Currency),
    gteThresholdText: z.string(),
    ltThresholdText: z.string(),
    addToCartButtonColor: z.string(),
    addToCartButtonTextColor: z.string(),
    progressBarColor: z.string(),
    excludedProductTags: z.array(z.string()),
    fallbackProductTags: z.array(z.string()),
  }),
  [CheckoutOptimizationWidgetType.FULFILLMENT_CUTOFF]: baseWidgetSchema.extend({
    type: z.literal(CheckoutOptimizationWidgetType.FULFILLMENT_CUTOFF),
    text: z.string(),
    backgroundColor: z.string(),
    iconColor: z.string(),
  }),
} satisfies Record<CheckoutOptimizationWidgetType, any>);

/**
 * The global state store for the checkout widgets builder.
 */
const checkoutWidgetsBuilderStateSchema = z.object({
  selectedWidget: createEnum(CheckoutOptimizationWidgetType),
  checkoutWidgets: checkoutWidgetsSchema,
});
export type CheckoutWidgetsBuilderState = z.infer<
  typeof checkoutWidgetsBuilderStateSchema
>;
